import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import { ADD_COMMENT } from '../../constants/actionTypes';

import { MDBContainer, MDBBtn } from 'mdbreact';

import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const mapDispatchToProps = dispatch => ({
  onSubmit: payload =>
    dispatch({ type: ADD_COMMENT, payload })
});

class CommentInput extends React.Component {
  constructor() {
    super();
    this.state = {
      body: ''
    };

    this.setBody = ev => {
      this.setState({ body: ev.target.value });
    };

    this.createComment = ev => {
      ev.preventDefault();

      if (this.props.authorizeCommentsBeforePublish) {
        confirmAlert({
          title: 'تنبيه',
          message: 'شكرا لك، \
          سيتم نشر التعليق بعد اعتماد إدارة المنصة. \
          التعليقات التي تحتوي على مخالفات لأحكام الشريعة الإسلامية سيتم تعديلها من إدارة المنصة.',
          buttons: [
            {
              label: 'موافق',
              onClick: () => this.sendComment()
            },
            {
              label: 'تراجع',
            }
          ]
        });
      } else {
        this.sendComment()
      }


    };
  }

  sendComment() {
    const payload = agent.Comments.create(this.props.slug,
      { body: this.state.body });
    this.setState({ body: '' });
    this.props.onSubmit(payload);
  }

  render() {
    return (
      <MDBContainer>
        <div className="d-md-flex flex-md-fill mt-4 px-1">
          <div className="d-flex justify-content-center ml-md-5">
            <img className="card-img-100 z-depth-1 mb-4"
              src={(!this.props.currentUser.image || /^\s*$/.test(this.props.currentUser.image)) ? "https://static.productionready.io/images/smiley-cyrus.jpg" : this.props.currentUser.image}
              alt="avatar" />
          </div>
          <textarea className="form-control pl-3 pt-3" id="exampleFormControlTextarea1" rows="6"
            placeholder="Write something here..."
            value={this.state.body}
            onChange={this.setBody}></textarea>
        </div>
        <div className="text-center mt-4">
          <MDBBtn color="primary" onClick={this.createComment}>Submit</MDBBtn>
        </div>
      </MDBContainer>
    );
  }
}

export default connect(() => ({}), mapDispatchToProps)(CommentInput);
